module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account--wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "delete-account-text"
  }, [_vm._v("1. Da biste obrisali nalog potrebno je da se prijavite.\n                  "), _c('br'), _vm._v("2. Nakon toga treba da kliknete u gornjem desnom uglu na svoj nalog\n                  "), _c('br'), _vm._v("3. Kada ste usli na svoj nalog, na dnu stranice imate dugme za brisanje naloga.\n                ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58095bf5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/DeleteAccount.vue
// module id = 768
// module chunks = 0